import { ActivationStatus, OrgFullDetail } from "@humanex/interfaces";

import { useOrgActivationQuery } from "@/hooks/queries/use-org-query";

import { OrgActivationPage } from "./org-activation.page";

interface OrgActivationGateProps {
  org: OrgFullDetail;
  children: React.ReactNode;
}

export function OrgActivationGate({ org, children }: OrgActivationGateProps) {
  const activationQuery = useOrgActivationQuery(org.id);

  if (activationQuery.isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-text-secondary text-sm">Đang tải...</div>
      </div>
    );
  }

  const status = activationQuery.data?.status;

  if (!status || status !== ActivationStatus.ACTIVE) {
    return (
      <OrgActivationPage
        orgId={org.id}
        orgName={org.name}
        activationStatus={activationQuery.data ?? { status: ActivationStatus.INACTIVE, plan: null }}
      />
    );
  }

  return <>{children}</>;
}
